import axios from "axios";
let API_BASE_URL = "";
let API_PATH = "";
if (process.env.NODE_ENV === "production") {
  /* 本番用 */
  API_BASE_URL = process.env.API_URL_PRODUCTION;
  API_PATH = `${API_BASE_URL}BiobankSearch/v2/`;
} else {
  /* テスト用 */
  API_BASE_URL = process.env.API_URL_DEVELOPMENT;
  API_PATH = `${API_BASE_URL}BiobankSearch/v2/`;
}

console.log("API_BASE_URL", API_BASE_URL);

const URL_MASTER_JSON = `${API_PATH}MasterFetch`;
const URL_SEARCH_ACCEPT = `${API_PATH}SearchAccept`;
const URL_CUSTOM_SEARCH_ACCEPT = `${API_PATH}CustomSearchAccept`;
const URL_RESULT_FETCH = `${API_PATH}ResultFetch`;
const URL_HISTORY_FETCH = `${API_PATH}HistoryFetch`;
const URL_ITEM_FETCH = `${API_PATH}ItemFetch`;
const URL_DEV_AUTH_URL = `${API_BASE_URL}v1/Auth`;

const functionsToExcute = []; //リクエストされたAPIを格納
let flag = true; //falseの時はapi呼ばれない

setInterval(() => {
  if (flag) {
    if (functionsToExcute.length > 0) {
      const head = functionsToExcute[0];
      functionsToExcute.shift();
      ajax(head[0], head[1], head[2], head[3]);
    }
  }
}, 100);

const api = (type, postData, callback, errorfunc) => {
  let checkFunctionExcute = true;
  functionsToExcute.map(ajax => {
    if (ajax.type === type) {
      checkFunctionExcute = false;
    }
  });
  if (checkFunctionExcute) {
    functionsToExcute.push([type, postData, callback, errorfunc]);
  }
};

const ajax = (type, postData, callback, errorfunc) => {
  switch (type) {
    case "masterFetch": {
      flag = false;
      return axios({
        method: "post",
        url: URL_MASTER_JSON,
        dataType: "json",
        contentType: "application/json"
      })
        .then(response => {
          callback(response.data);
          flag = true;
        })
        .catch(error => {
          console.log("fetch error");
          /* api取得失敗なのでトップに戻る */
          window.location.pathname = "/";
          flag = true;
        });
    }

    case "historyFetch": {
      flag = false;
      return axios({
        method: "post",
        url: URL_HISTORY_FETCH,
        data: {},
        dataType: "json",
        contentType: "application/json"
      })
        .then(response => {
          callback(response.data.search_history_list);
          flag = true;
        })
        .catch(e => {
          console.log("history fetch error", e);
          flag = true;
        });
    }

    case "postApi": {
      flag = false;

      return axios({
        method: "post",
        url: URL_SEARCH_ACCEPT,
        data: postData
      })
        .then(response => {
          callback(response);
          flag = true;
        })
        .catch(error => {
          console.log("post失敗", error);
          errorfunc(error);
          flag = true;
        });
    }

    case "postResultFetch": {
      flag = false;
      return axios({
        method: "post",
        url: URL_RESULT_FETCH,
        data: postData
      })
        .then(response => {
          callback(response.data);
          flag = true;
        })
        .catch(error => {
          console.log("postResultFetch失敗");
          setTimeout(() => {
            api("postResultFetch", postData, callback);
          }, 2000);
          flag = true;
        });
    }

    case "postItemFetch": {
      const query = { item: postData };
      flag = false;
      return axios({
        method: "post",
        url: URL_ITEM_FETCH,
        data: query
      })
        .then(response => {
          callback(response.data);
          flag = true;
        })
        .catch(error => {
          console.log("postItemFetch失敗", error);
          errorfunc();
          flag = true;
        });
    }

    case "auth": {
      flag = false;
      const params = new URLSearchParams();
      params.append("access_token", "12345678901234567890123456789012");
      return axios({
        method: "POST",
        url: URL_DEV_AUTH_URL,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        withCredentials: true,
        params
      })
        .then(res => {
          callback(res.data);
        })
        .catch(error => {
          console.log("Auth Error", error.response);
          errorfunc(error);
        })
        .finally(() => (flag = true));
    }
  }
};

export default api;
